const numberToLocaleString = num => num.toLocaleString('en-US')

export {
  numberToLocaleString
}
